// removed by extract-text-webpack-plugin
module.exports = {"error":"style__error__2rfyJ","facebook_button":"style__facebook_button__12V68"};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/facebook/style.scss
// module id = 231
// module chunks = 0